@if (componentType === 'gridRow' || componentType === 'gridRowWithFacets') {
    <div #zone [id]="zoneId"></div>
}